import { jsx as _jsx } from "react/jsx-runtime";
import { ProjectsFallback } from '@widgets/projectsFallback';
export function ErrorPage() {
    return _jsx(ProjectsFallback, {});
}
